import { MadeInFrance } from '@components/made-in-france/models';
import { Block } from '@shared/models';

export const madeInFranceMock: Block<MadeInFrance> = {
  type: 'made-in-france',
  data: {
    title: {
      text: `Des cuisines \\\\[[Made in France]]`,
      as: 'span',
    },
    picto: {
      svg: '/assets/tmp/store.svg',
    },
  },
};
